module.exports = __webpack_public_path__ + "img/heart_line.c17cb1e7.svg";